import styled from 'styled-components';
import {V6} from '../../theme';
import {Badge} from './Badge';

export const InBasketBadge = styled(Badge)`
  background-color: ${V6.badges.backgroundColors.basket};
`;
